import { put, call, takeLatest } from "redux-saga/effects";
import { notification } from "antd";
import { userListApi, userDeleteApi, addUserApi } from "../Api/api";
import {
  userListFailed,
  userDeleteLoad,
  userDeleteSuccess,
  userDeleteFailed,
  addUserLoad,
  addUserSuccess,
  addUserFail,
  userListManageMentSuccess,
  userListManageMentLoad,
} from "../slices/user.slice";
import { navigate } from "../../common/navigator";
import { toast } from "react-toastify";

function* userListSaga(action) {
  try {
    const data = yield call(userListApi, action.payload);
    if (data.status === 0) {
      yield put(
        userListManageMentSuccess({
          data: data.result.data,
          pagination: data.result.pagination,
        })
      );
    } else {
      yield put(userListFailed());
    }
  } catch {
    yield put(userListFailed());
  }
}

function* userDeleteSaga(action) {
  try {
    const data = yield call(userDeleteApi, action.payload.key);
    if (data.status === 0) {
      yield put(userDeleteSuccess());
      yield put(userListManageMentLoad(action.payload)); // Reload the user list
      toast.success(data?.result?.message);
    } else {
      yield put(userDeleteFailed());
      toast.error(data?.result?.message);
    }
  } catch (error) {
    yield put(userDeleteFailed());
    toast.error(error);
  }
}

function* addUserSaga(action) {
  try {
    let data = yield call(addUserApi, action.payload);
    if (data.status === 0) {
      toast.success(data?.result?.message);
      yield put(addUserSuccess());
      yield put(userListManageMentLoad(action.payload));
    } else {
      toast.error(data?.result?.message);
      yield put(addUserFail());
    }
  } catch (error) {
    yield put(addUserFail());
    toast.error(error);
  }
}

export default function* rootUserManagementSaga() {
  yield takeLatest(userListManageMentLoad.type, userListSaga);
  yield takeLatest(userDeleteLoad.type, userDeleteSaga);
  yield takeLatest(addUserLoad.type, addUserSaga);
}
